import {
  Flex, Image, Spacer, Stack,
  useOutsideClick,
  Box
} from '@chakra-ui/react'
// eslint-disable-next-line import/no-extraneous-dependencies
import Carousel from 'react-multi-carousel'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { markersSelectors, toggleImageCarousel } from 'store'
import { motion } from 'framer-motion'

export const ImageCarouselModal = () => {
  const carouselContainerRef = useRef()
  const carouselRef = useRef()
  const { eventData } = useSelector(markersSelectors)
  const [openCarousel, setOpenCarousel] = useState(false)
  const ImageCarouselStatus = localStorage.getItem('image-carousel-display')
  const imageCount = eventData?.additional_images.length
  const { isImageCarouselOpen } = useSelector(markersSelectors)
  const dispatch = useDispatch()

  let imageIndex = localStorage.getItem('image-current-slide')

  // useOutsideClick({
  //   ref: carouselContainerRef,
  //   handler: () => {
  //     dispatch(toggleImageCarousel(false))
  //   }
  // })

  const goTo = (index) => {
    carouselRef.current?.goToSlide(index)
  }

  const responsive = {
    superLargeDesktop: {
    // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  }

  const boxVariants = {
    open: { opacity: 1 },
    closed: { opacity: 0 }
  }

  return (
    <Stack
      sx={{
        width: '100vw',
        height: '92.5vh',
        position: 'absolute',
        top: 0,
        zIndex: 400,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        '@media (max-width: 1024px)': {
          height: '88vh'
        }
      }}
      onLoad={() => goTo(imageIndex)}
    >
      <Box
        width="100%"
        height="100%"
        position="absolute"
        zIndex={401}
        onClick={() => dispatch(toggleImageCarousel(false))}
      />
      <Stack
        sx={{
          zIndex: 402,
          width: '50%',
          height: '45vh',
          marginBlock: '10%',
          alignSelf: 'center',
          '@media (max-width: 1024px)': {
            width: '100%',
            height: '35vh',
            marginBlock: '60%'
          }
        }}
        ref={carouselContainerRef}
      >
        <motion.div
          variants={boxVariants}
          animate={isImageCarouselOpen === true ? 'open' : 'closed'}
          transition={{ duration: 0.8 }}
        >
          <Carousel
            focusOnSelect
            responsive={responsive}
            swipeable
            draggable
            arrows={false}
            ref={carouselRef}
          >
            {eventData?.additional_images.map((e) => <Image src={e} width="100vw" draggable={false} borderRadius="5px" />)}
          </Carousel>
        </motion.div>
      </Stack>
    </Stack>
  )
}
